const SERVER_BASE_URL = import.meta.env.VITE_SERVER_BASE_URL;
const SOCKET_URL = import.meta.env.VITE_SOCKET_URL;
const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;
const FE_DOMAIN = import.meta.env.VITE_FE_DOMAIN;
const OPEN_AI_KEY = import.meta.env.VITE_OPEN_AI_KEY;
const MOONPAY_API_KEY =import.meta.env.MOONPAY_API_KEY;

const firebase_config = {
  API_KEY: import.meta.env.VITE_API_KEY,
  AUTH_DOMAIN: import.meta.env.VITE_AUTH_DOMAIN,
  PROJECT_ID: import.meta.env.VITE_PROJECT_ID,
  STORAGE_BUCKET: import.meta.env.VITE_STORAGE_BUCKET,
  MESSAGING_SENDER_ID: import.meta.env.VITE_MESSAGING_SENDER_ID,
  APP_ID: import.meta.env.VITE_APP_ID,
  MEASUREMENT_ID: import.meta.env.VITE_MEASUREMENT_ID,
};


export {
  SERVER_BASE_URL,
  SOCKET_URL,
  INTERCOM_APP_ID,
  firebase_config,
  FE_DOMAIN,
  OPEN_AI_KEY,
  MOONPAY_API_KEY
};
